/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UISlider from 'UIComponents/input/UISlider';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { createSteppingFunction } from 'pricing-pages-unified-ui/utils/merchandiseUtils';
const MiddleGrid = styled.div.withConfig({
  displayName: "ContactsSlider__MiddleGrid",
  componentId: "sc-5lwa0d-0"
})(["display:grid;grid-template-columns:1fr auto;grid-column-gap:16px;"]);
const BottomLabel = styled.div.withConfig({
  displayName: "ContactsSlider__BottomLabel",
  componentId: "sc-5lwa0d-1"
})(["cursor:pointer;font-size:12px;"]);

const ContactsSlider = props => {
  const {
    initialValue = 0,
    value = null,
    onChange = () => {},
    min,
    trackStart = min,
    max,
    step,
    title,
    description,
    disabled = false,
    numberInputClassName = '',
    labelsBelowSlider = false,
    restrictedAreaTooltip
  } = props;
  const isFullyControlled = value != null;
  const [rawValue, setRawValue] = useState(initialValue);
  const [rawRoundUp, setRawRoundUp] = useState(false);
  const calculatedValue = createSteppingFunction(min, max, step)(rawValue, rawRoundUp);
  useEffect(() => {
    if (!isFullyControlled && onChange) {
      onChange(calculatedValue);
    }
  }, [isFullyControlled, calculatedValue]);
  const displayValue = isFullyControlled ? value : calculatedValue;

  const handleValueChange = (newRawValue, roundUp = false) => {
    if (isFullyControlled) {
      if (onChange) onChange(newRawValue, roundUp);
    } else {
      setRawValue(newRawValue);
      setRawRoundUp(roundUp);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [title, /*#__PURE__*/_jsxs(MiddleGrid, {
      children: [/*#__PURE__*/_jsx("div", {
        children: description
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UINumberInput, {
          value: displayValue,
          onChange: ({
            target: {
              value: newValue
            }
          }) => handleValueChange(newValue, true),
          disabled: disabled,
          className: numberInputClassName,
          "data-selenium-id": "contacts-picker-input"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "p-top-5",
      children: /*#__PURE__*/_jsx(UISlider, {
        size: "large",
        min: min > max ? max : min,
        minLabel: /*#__PURE__*/_jsx(FormattedNumber, {
          value: trackStart
        }),
        trackStart: trackStart,
        max: max,
        maxLabel: /*#__PURE__*/_jsx(FormattedNumber, {
          value: max
        }),
        value: displayValue,
        showLabels: !labelsBelowSlider,
        onChange: ({
          target: {
            value: newValue
          }
        }) => handleValueChange(newValue),
        restrictedAreaTooltip: restrictedAreaTooltip,
        disabled: disabled
      })
    }), labelsBelowSlider && /*#__PURE__*/_jsxs("div", {
      className: "flex-row m-top-2",
      children: [/*#__PURE__*/_jsx(BottomLabel, {
        onClick: () => handleValueChange(min),
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          value: trackStart
        })
      }), /*#__PURE__*/_jsx(BottomLabel, {
        className: "m-left-auto",
        onClick: () => handleValueChange(max),
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          value: max
        })
      })]
    })]
  });
};

ContactsSlider.propTypes = {
  initialValue: PropTypes.number,
  value: PropTypes.number,
  min: PropTypes.number.isRequired,
  trackStart: PropTypes.number,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  numberInputClassName: PropTypes.string,
  labelsBelowSlider: PropTypes.bool,
  restrictedAreaTooltip: PropTypes.node
};
export default ContactsSlider;